import React from 'react'
import { Outlet } from 'react-router-dom'
import { Tooltip } from 'react-tooltip'
import { connect } from 'react-redux'

import css from './Layout.module.scss'
import NotificationQueue from '../../UI/NotificationQueue/NotificationQueue'
import Navigator from './Navigator/Navigator'
import CheckAuth from './CheckAuth/CheckAuth'
import ReduxLoader from './ReduxLoader/ReduxLoader'
import Logo from '../../../assets/logo.svg'
import packageJson from '../../../../package.json'

const Layout = () => (
  <div className={css.Layout}>
    <CheckAuth />
    <Navigator />
    <Outlet />
    <NotificationQueue />
    <ReduxLoader />
    <Tooltip id='bulk' />
    <div className={css.Footer}>
      &copy;{new Date().getFullYear()} BulkZone.io - v. {packageJson.version}
      <img src={Logo} alt='BulkZone' className={css.Logo} />
    </div>
  </div>
)

export default connect((state) => {
  return state
})(Layout)
